import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeMount, onBeforeUnmount, ref, watch } from 'vue'
import { emitter } from '@/plugins/emitter'
import { useHostServices } from '@/composables/format-edit/useHostServices'
import { useFormatLocalData } from '@/composables/format-edit/useFormatLocalData'
import {
  createEmptyTaishokutodokeFormatData,
  provideTaishokutodokeFormatData
} from '@/composables/format-edit/useTaishokutodokeFormatData'
import type { LetterExampleSentenceItem } from '@/components/format-edit/letter/LetterExampleSentenceDialog.vue'
import TaishokutodokeCompanyCard from '@/components/format-edit/taishokutodoke/TaishokutodokeCompanyCard.vue'
import TaishokutodokeTextareaCard from '@/components/format-edit/taishokutodoke/TaishokutodokeTextareaCard.vue'
import TaishokutodokeDateCard from '@/components/format-edit/taishokutodoke/TaishokutodokeDateCard.vue'
import LetterConfirmCard from '@/components/format-edit/letter/LetterConfirmCard.vue'
import DownloadItem from '@/components/formats/CommonParts/DownloadItem.vue'

type DateFormLib = {
  getToday: () => Date
  dateFormat: (date: Date, format: string) => string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TaishokutodokeEdit',
  props: {
    basicData: null,
    formatId: null,
    previewFormat: null,
    currentCardId: null,
    exampleSentences: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
  basicData: Record<string, unknown>
  formatId?: string
  previewFormat?: { errorMessages?: Record<string, string> } | null
  currentCardId?: string
  exampleSentences?: {
    intro?: LetterExampleSentenceItem[]
    entry?: LetterExampleSentenceItem[]
  }
};



const { formLib } = useHostServices()

const { formatData, saveKey, saveName, changeCount } = useFormatLocalData({
  saveName: 'taishokutodoke',
  saveOtherName: 'rirekisho',
  createEmpty: createEmptyTaishokutodokeFormatData
})
provideTaishokutodokeFormatData(formatData)

const mailPdfEnabled = ref(true)
const downloadPdfEnabled = ref(true)
const isSendYagiPostEnabled = ref(true)
const isSendYagiEmailEnabled = ref(true)
const downloadActiveCollapses = ref(['postcard'])

const previewErrors = computed(() => {
  if (!props.previewFormat || !props.previewFormat.errorMessages) return {}
  return props.previewFormat.errorMessages
})

const getMode = computed(() => process.env.VUE_APP_MODE)

const entrySentences = computed(() => props.exampleSentences?.entry || [])

function dataChanged() {
  mailPdfEnabled.value = true
  downloadPdfEnabled.value = true
}

const dateFormLib = formLib as typeof formLib & DateFormLib

watch(
  () => formatData.createDate,
  (newValue) => {
    if (newValue == null) return
    formatData.writeDate = dateFormLib.dateFormat(
      newValue as Date,
      'yyyy年 m月 d日'
    )
  }
)

onBeforeMount(() => {
  if (formatData.createDate === null) {
    formatData.createDate = dateFormLib.getToday()
  }
  if (formatData.retirementDate === null) {
    formatData.retirementDate = dateFormLib.getToday()
  }
  emitter.on('basic-data-changed', dataChanged)
  emitter.on('format-data-changed', dataChanged)
})

onBeforeUnmount(() => {
  emitter.off('basic-data-changed', dataChanged)
  emitter.off('format-data-changed', dataChanged)
})

expose({
  saveName,
  saveKey,
  formatData,
  changeCount
})

return { __sfc: true,props, formLib, formatData, saveKey, saveName, changeCount, mailPdfEnabled, downloadPdfEnabled, isSendYagiPostEnabled, isSendYagiEmailEnabled, downloadActiveCollapses, previewErrors, getMode, entrySentences, dataChanged, dateFormLib, TaishokutodokeCompanyCard, TaishokutodokeTextareaCard, TaishokutodokeDateCard, LetterConfirmCard, DownloadItem }
}

})